export default __webpack_public_path__ + "static/media/search-all-patients.008b5ad9.svg";